






























































import Vue from 'vue'
import Component from 'vue-class-component'
import ModalV2 from '@/components/modals/ModalV2.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import { required } from 'vuelidate/lib/validators'
import Icon from '@/components/Icon.vue'
import ScrollView from '@/components/ScrollView.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import { IFacilityPayerGroup } from '@zunta/configurations'
import { FacilityModule } from '@/store/modules/facility.module'
import { getModule } from 'vuex-module-decorators'

@Component({
  components: { InputValidator, ScrollView, Icon, InputV2, ModalV2 }
})
export default class PayerGroupModal extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  groups: Array<Partial<IFacilityPayerGroup>> = []

  groupsToRemove: Array<Partial<IFacilityPayerGroup>> = []
  groupsToAdd: Array<Partial<IFacilityPayerGroup>> = []

  isLoading: boolean = false

  validations (): any {
    return {
      groups: {
        $each: {
          payerGroupName: {
            required
          }
        }
      }
    }
  }

  get payerGroup (): IFacilityPayerGroup[] {
    return this.$store.state.facility.facilityPayerGroups || []
  }

  get selectedFacility () {
    return this.$store.state.facility.selectedFacility
  }

  mounted () {
    this.groups = JSON.parse(JSON.stringify(this.payerGroup))
    if (!this.groups.length) {
      this.addGroup()
    }
  }

  addGroup () {
    this.groups.push({
      payerGroupName: '',
      facility: Number(this.selectedFacility.id)
    })
  }

  removeGroup (index: number) {
    if (!this.groups[index]) {
      return
    }

    if (this.groups[index].id) {
      this.groupsToRemove.push(this.groups[index])
    }

    this.groups.splice(index, 1)
  }

  async save () {
    this.$v.$touch()

    if (this.$v.$anyError) {
      return
    }

    const groupsToUpdate: any[] = this.groups
      .filter((item: Partial<IFacilityPayerGroup>) => !!item.id)
      .map((item: Partial<IFacilityPayerGroup>) => (this.facilityModuleInstance.updateFacilityPayerGroup({ facilityPayerGroupId: item.id as number, group: item })))
    // const groupsToCreate: any[] = this.groups
    //   .filter((item: Partial<IFacilityPayerGroup>) => !item.id)
    //   .map((item: Partial<IFacilityPayerGroup>) => (this.facilityModuleInstance.createFacilityPayerGroup(item)))
    const groupsToRemove: any[] = this.groupsToRemove
      .map((item: Partial<IFacilityPayerGroup>) => (this.facilityModuleInstance.deleteFacilityPayerGroup(item.id as number)))

    try {
      this.isLoading = true
      await Promise.all([
        ...groupsToRemove,
        // ...groupsToCreate,
        ...groupsToUpdate
      ])
      const groupsToCreate: any[] = this.groups.filter((item: Partial<IFacilityPayerGroup>) => !item.id)

      for (const item of groupsToCreate) {
       await this.facilityModuleInstance.createFacilityPayerGroup(item)
      }

      this.$emit('save')
    } finally {
      this.isLoading = false
      this.$emit('close')
    }
  }
}
